import React, { Component } from "react";
import {
  View,
  StatusBar,
  Text,
  TouchableOpacity,
  Image,
} from "react-native-web";
import BackgroundImage from "../../components/BackgroundImage";
import HeaderBar from "../../components/HeaderBar";
import localforage from "localforage";
import gql from "graphql-tag";
import { withRouter } from "react-router";
import ApolloClient from "apollo-boost";
import queryString from "query-string";
import { FormModal } from "../../components/Modal";
import { withI18n, translate } from "../../libs/withI18n";
import FileSaver from "file-saver";
import * as NQRCode from "qrcode";
import { handleError } from "../../libs/errors";
import { ShimmerThumbnail } from "react-shimmer-effects";
import lodash from "lodash";
import { LoadingOverlay } from "../../components/Overlay";
import {
  showLoadingSpinner,
  hideLoadingSpinner,
  addNotification,
} from "../../App";
import { CopyToClipboard } from "react-copy-to-clipboard";
import dayjs from "dayjs";

let urlValues;

const MONTHS = [
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Insidental",
];

class StudentBillAndPaymentNewV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listSiswa: [],
      loading: false,
      selectedSiswa: null,
      listTagihan: null,
      showFilter: false,
      height: 0,
      selectedBills: [],

      listTahunAjaran: [],

      filterCriteria: {
        studentId: "",
        academicYear: "",
        type: "",
      },
      previousTransaction: null,
      showPreviousTransactionModal: false,
      vaCopied: false,

      checkOutModal: {
        visible: false,
        total: 0,
        fee: 0,
        totalBill: 0,
      },
      paymentChannelModalVisible: false,
      paymentMethod: "",

      successCheckOutModal: {
        visible: false,
        vaNumber: "",
        bankCode: "",
      },

      qrisObject: {
        qrisModalVisible: false,
      },
      selectedTagihanBulan: [],
      paymentChannels: [],
      isPaymentH2H: false,
    };
    this.qrcode = React.createRef();
  }

  PAYMENT_METHODS = [
    {
      name: "linkAja",
      label: "LINK AJA",
      type: "ewallet",
    },
    {
      name: "tokopedia",
      label: "TOKOPEDIA",
      type: "ecommerce",
    },
    {
      name: "shopee",
      label: "SHOPEE",
      type: "ecommerce",
    },
    // {
    //   name: "ovo",
    //   label: "OVO",
    //   icon: "/static/images/OVO.png",
    // },
    // {
    //   name: "dana",
    //   label: "DANA",
    //   icon: "/static/images/dana.png",
    // },
    {
      name: "bca",
      label: "BANK BCA",
      type: "va",
    },
    {
      name: "mandiri",
      label: "BANK MANDIRI",
      type: "va",
    },
    {
      name: "bni",
      label: "BANK BNI",
      type: "va",
    },
    {
      name: "bri",
      label: "BANK BRI",
      type: "va",
    },
    {
      name: "bsi",
      label: "BANK BSI",
      type: "va",
    },
    {
      name: "permata",
      label: "BANK PERMATA",
      type: "va",
    },
    // {
    //   name: "qris",
    //   label: "QRIS",
    //
    //   type: "qris",
    //   display: this.props.router.query.PREFIX === "DEMO" ? "block" : "none",
    // },
    {
      name: "cimb",
      label: "BANK CIMB NIAGA",
      type: "va",
    },
    // {
    //   name: "btn",
    //   label: "BANK BTN",
    //   icon: "/static/images/BTN.png",
    //   type: "va",
    //   display: this.props.router.query.PREFIX === "DEMO" ? "block" : "none",
    // },
    // {
    //   name: "muamalat",
    //   label: "BANK MUAMALAT",
    //   icon: "/static/images/muamalat.png",
    //   type: "va",
    //   display: this.props.router.query.PREFIX === "DEMO" ? "block" : "none",
    // },
  ];

  componentWillReceiveProps = () => {
    this.componentDidMount();
  };

  componentDidMount = async () => {
    urlValues = queryString.parse(this.props.location.search);

    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.setState({
      loading: true,
    });

    const res = await this.refetchData({
      sessionId: urlValues.sessionId,
      studentId: "",
      type: "",
      academicYear: "",
    });

    this.setState({
      loading: false,
      listSiswa: res.listSiswa,
      selectedSiswa: res.selectedSiswa,
      listTagihan: res.listTagihan,
      filterCriteria: res.filterCriteria,
      listTahunAjaran: res.listTahunAjaran,
      paymentChannels: res.paymentChannels,
    });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  resize() {
    if (this.divElement) {
      const height = this.divElement.clientHeight;
      this.setState({
        height,
      });
    }

    let currentHideNav = window.innerWidth <= 760;
    if (currentHideNav !== this.state.hideNav) {
      this.setState({ hideNav: currentHideNav });
    }
  }

  refetchData = async ({
    sessionId,
    studentId,
    type,
    academicYear,
    PREFIX,
  }) => {
    try {
      urlValues = queryString.parse(this.props.location.search);
      const res = await mwvClient.query({
        query: ALL_STUDENT_QUERIES,
        variables: {
          _id: sessionId,
          PREFIX: PREFIX ? PREFIX : urlValues.PREFIX,
          studentId: studentId
            ? studentId
            : urlValues.studentId
            ? urlValues.studentId
            : "",
        },
        fetchPolicy: "no-cache",
      });

      const listTahunAjaran = res.data.allAcademicYears;

      // console.log("listTahunAjaran", listTahunAjaran);

      let selectedSiswa = null;
      if (!studentId) {
        selectedSiswa = res.data.allStudentBySessionId[0];
      } else {
        selectedSiswa = res.data.allStudentBySessionId.find(
          (siswa) => siswa._id === studentId
        );
      }

      let tahunAjaran = "";
      if (!academicYear) {
        const found = listTahunAjaran.find((ta) => ta.inProgress);
        tahunAjaran = found.label;
      } else {
        tahunAjaran = academicYear;
      }

      if (!tahunAjaran) {
        throw new Error("Invalid Academic Year.");
      }

      const resBill = await mwvClient.query({
        query: ALL_STUDENT_BILLS,
        variables: {
          studentId: selectedSiswa._id,
          type,
          academicYear: tahunAjaran,
        },
      });

      let listTagihan = {};
      if (resBill.data.allStudentBillNew.length > 0) {
        const indexed = resBill.data.allStudentBillNew.reduce((all, b) => {
          if (!all[b.month]) {
            all[b.month] = [];
          }
          all[b.month].push(b);
          return all;
        }, {});

        for (const m of MONTHS) {
          if (indexed[m]) {
            listTagihan[m] = indexed[m];
          }
        }
      }
      return {
        listTagihan,
        selectedSiswa,
        listSiswa: res.data.allStudentBySessionId,
        listTahunAjaran,
        filterCriteria: {
          studentId,
          academicYear: tahunAjaran,
          type,
        },
        paymentChannels: res.data.h2hChecker,
      };
    } catch (err) {
      handleError(err);
    }
  };

  openFilter = async (e) => {
    if (e) e.preventDefault();
    showLoadingSpinner();
    try {
      urlValues = queryString.parse(this.props.location.search);

      this.setState({
        loading: true,
      });
      const { filterCriteria } = this.state;
      // console.log(filterCriteria);
      const res = await this.refetchData({
        sessionId: urlValues.sessionId,
        studentId: filterCriteria.studentId,
        type: filterCriteria.type,
        academicYear: filterCriteria.academicYear,
      });

      this.setState({
        loading: false,
        showFilter: true,
        listSiswa: res.listSiswa,
        selectedSiswa: res.selectedSiswa,
        listTagihan: res.listTagihan,
        listTahunAjaran: res.listTahunAjaran,
        filterCriteria: {
          studentId: res.selectedSiswa._id,
          academicYear: filterCriteria.academicYear,
          type: "",
        },
      });
    } catch (err) {
      handleError(err);
    }
    hideLoadingSpinner();
  };

  handleFilterCriteria = (key) => async (e) => {
    if (e) e.preventDefault();
    if (key === "studentId") {
      this.setState({
        filterCriteria: {
          ...this.state.filterCriteria,
          studentId: e.target.value,
        },
      });
      const resTA = await mwvClient.query({
        query: ALL_ACADEMIC_YEAR_BY_STUDENT,
        variables: {
          studentId: e.target.value,
        },
        fetchPolicy: "no-cache",
      });
      const tahunAjaranAktifDefault =
        resTA.data.allAcademicYearsByStudent.filter((ta) => ta.inProgress)[0]
          .label;
      this.setState({
        listTahunAjaran: resTA.data.allAcademicYearsByStudent,
        filterCriteria: {
          ...this.state.filterCriteria,
          academicYear: tahunAjaranAktifDefault,
        },
      });
    } else {
      this.setState({
        filterCriteria: {
          ...this.state.filterCriteria,
          [key]: e.target.value,
        },
      });
    }
  };

  submitFilter = async (e) => {
    if (e) e.preventDefault();
    showLoadingSpinner();
    const { filterCriteria, listSiswa } = this.state;
    urlValues = queryString.parse(this.props.location.search);

    this.setState({
      loading: true,
    });
    try {
      let PREFIX = "";
      const found = listSiswa.find((s) => s._id === filterCriteria.studentId);
      if (found) {
        PREFIX = found.PREFIX;
      }

      const res = await this.refetchData({
        sessionId: urlValues.sessionId,
        studentId: filterCriteria.studentId,
        type: filterCriteria.type,
        academicYear: filterCriteria.academicYear,
        PREFIX,
      });

      this.setState({
        loading: false,
        showFilter: false,
        listSiswa: res.listSiswa,
        selectedSiswa: res.selectedSiswa,
        listTagihan: res.listTagihan,
        listTahunAjaran: res.listTahunAjaran,
      });
    } catch (err) {
      handleError(err);
    }

    hideLoadingSpinner();
  };

  handleSelectBill = (bill) => (e) => {
    if (e) e.preventDefault();

    if (this.state.selectedBills.length === 0) {
      this.setState({
        selectedBills: [bill],
      });
    } else {
      const findIndex = this.state.selectedBills
        .map((b) => b._id)
        .findIndex((bi) => bi === bill._id);

      if (findIndex > -1) {
        this.setState({
          selectedBills: this.state.selectedBills.filter(
            (b) => b._id !== bill._id
          ),
        });
      } else {
        this.setState({
          selectedBills: [...this.state.selectedBills, bill],
        });
      }
    }
  };

  openHistory = (e) => {
    if (e) e.preventDefault();
    urlValues = queryString.parse(this.props.location.search);
    const { router } = this.props;
    const tahunAjaran = this.state.listTahunAjaran.find((ta) => ta.inProgress);

    let urlParams = {
      ...urlValues,
      studentId: this.state.selectedSiswa._id,
      academicYear: tahunAjaran.label,
      isV2: true,
    };
    urlParams = queryString.stringify(urlParams);
    window.location.href = `/student_bill/school_pay_history_new?${urlParams}`;
  };

  openCheckOut = (selectedBills) => async (e) => {
    if (e) e.preventDefault();
    showLoadingSpinner();

    try {
      urlValues = queryString.parse(this.props.location.search);

      const result = await mwvClient.mutate({
        mutation: CHECK_PREVIOUS_TRANSACTION,
        variables: {
          sessionId: urlValues.sessionId,
        },
        fetchPolicy: "no-cache",
      });

      if (result.data.checkPreviousTransaction) {
        const VAPaymentDetail = JSON.parse(
          result.data.checkPreviousTransaction.VAPaymentDetail
        );

        let virtualAccount = "";
        let checkOutUrl = "";
        if (VAPaymentDetail.provider === "MCP") {
          virtualAccount = VAPaymentDetail.payment_code;
        } else if (VAPaymentDetail.provider === "XENDIT") {
          virtualAccount = VAPaymentDetail.account_number;
        } else if (VAPaymentDetail.provider === "FASPAY") {
          if (VAPaymentDetail.bankCode === "BCA") {
            virtualAccount = VAPaymentDetail.va_number;
          } else if (VAPaymentDetail.redirect_url) {
            checkOutUrl = VAPaymentDetail.redirect_url;
          }
        } else if (VAPaymentDetail.provider === "SEVIMA") {
          virtualAccount = VAPaymentDetail.virtual_account;
        } else if (VAPaymentDetail.provider === "BNIH2H") {
          virtualAccount = VAPaymentDetail.virtualAccount;
        }

        this.setState({
          showPreviousTransactionModal: true,
          previousTransaction: {
            ...result.data.checkPreviousTransaction,
            VAPaymentDetail: JSON.parse(
              result.data.checkPreviousTransaction.VAPaymentDetail
            ),
            checkOutUrl,
            virtualAccount,
          },
          paymentChannelModalVisible: false,
        });
      } else {
        //Buka payment channellnya...

        const { paymentMethod, isPaymentH2H } = this.state;
        let fee = 0;
        if (isPaymentH2H) {
          if (selectedBills[0].PREFIX === "INKA") {
            fee = 2000;
          } else if (selectedBills[0].PREFIX === "SMAALFALAH") {
            fee = 1000;
          } else {
            fee = 0;
          }
        } else {
          if (paymentMethod === "bca") {
            fee = 4500;
          } else if (paymentMethod === "linkAja") {
            fee = 4000;
          } else if (paymentMethod === "bsi") {
            fee = 4500;
          } else if (paymentMethod === "bni") {
            fee = 3800;
          } else if (paymentMethod === "mandiri") {
            fee = 4000;
          } else if (paymentMethod === "btn") {
            fee = 1500;
          } else if (
            paymentMethod === "tokopedia" ||
            paymentMethod === "shopee"
          ) {
            fee = 1000;
          } else {
            fee = 3500;
          }
        }

        const total =
          selectedBills
            .map((bill) => bill.unpaid)
            .reduce((acc, curr) => acc + curr, 0) + fee;
        const totalBill = selectedBills
          .map((bill) => bill.unpaid)
          .reduce((acc, curr) => acc + curr, 0);

        // console.log({ total, totalBill, fee });
        this.setState({
          checkOutModal: {
            visible: true,
            total,
            totalBill,
            fee,
          },
          selectedBills,
          paymentChannelModalVisible: false,
        });
      }

      // console.log(this.state.height);
    } catch (err) {
      handleError(err);
    }
    hideLoadingSpinner();
  };

  closeCheckOutModal = () => {
    this.setState({
      selectedBills: [],
      checkOutModal: {
        visible: false,
        total: 0,
        fee: 0,
        totalBill: 0,
      },
    });
  };

  linkAjaContinue = (previousTransaction) => (e) => {
    window.open(previousTransaction.checkOutUrl, "__blank");
  };

  openPaymentChannel = async () => {
    showLoadingSpinner();
    try {
      const { selectedBills, paymentMethod, fee } = this.state;

      urlValues = queryString.parse(this.props.location.search);

      const nowHours = dayjs().hour();
      if (nowHours >= 21 || nowHours <= 4) {
        throw {
          message:
            "Cut Off. Silahkan lakukan pembayaran diatas jam 04:00 - 21:00",
        };
      }

      const checkIfH2H = await this.props.client.query({
        query: CHECK_IF_SCHOOL_IS_H2H,
        variables: {
          PREFIX: selectedBills[0].PREFIX,
        },
        fetchPolicy: "no-cache",
      });

      if (checkIfH2H.data.checkIfUseH2H === false) {
        const result = await mwvClient.mutate({
          mutation: CHECK_PREVIOUS_TRANSACTION_V2,
          variables: {
            sessionId: urlValues.sessionId,
            isV2: true,
          },
          fetchPolicy: "no-cache",
        });

        if (result.data.checkPreviousTransactionV2) {
          this.setState({
            showPreviousTransactionModal: true,
            previousTransaction: result.data.checkPreviousTransactionV2,
          });
        } else {
          const { selectedBills, paymentMethod, fee } = this.state;

          const totalBills = selectedBills
            .map((c) => c.unpaid)
            .reduce((acc, curr) => acc + curr, 0);

          let histories = selectedBills.map((bill) => {
            return {
              studentBillId: bill._id,
              paid: bill.unpaid,
            };
          });

          const result = await mwvClient.mutate({
            mutation: CREATE_SCHOOL_PAY_V2,
            variables: {
              sessionId: urlValues.sessionId,
              studentBillIds: selectedBills.map((s) => s._id),

              total: totalBills,
              fee: 0,
              histories,
              PWAMode: true,
              sourceUrl: window.location.href,
            },
            fetchPolicy: "no-cache",
          });

          if (result.data.createSchoolPayBillV2) {
            addNotification({
              level: "success",
              message: "Redirecting...",
            });
            setTimeout(() => {
              window.location.href = result.data.createSchoolPayBillV2;
              // window.open(
              //   result.data.createSchoolPayBillV2,
              //   "_blank" // <- This is what makes it open in a new window.
              // );
            }, 2000);
          }
        }
      }
    } catch (err) {
      handleError(err);
    }
    hideLoadingSpinner();
  };

  handleSelectPayment = (key) => (e) => {
    const { paymentChannels } = this.state;
    let isH2H = false;
    const found = paymentChannels.find((p) => p.name === key);
    if (found.isH2H && found.isH2H === true) {
      isH2H = true;
    }

    this.setState({
      paymentMethod: key,
      isPaymentH2H: isH2H,
    });
  };

  refresh = () => {
    window.location.reload();
  };

  expandTagihan = (bulanTagihan) => (e) => {
    const { selectedTagihanBulan } = this.state;
    const findIndex = selectedTagihanBulan.indexOf(bulanTagihan);

    if (findIndex < 0) {
      this.setState({
        selectedTagihanBulan: [...selectedTagihanBulan, bulanTagihan],
      });
    } else {
      this.setState({
        selectedTagihanBulan: selectedTagihanBulan.filter(
          (t) => t !== bulanTagihan
        ),
      });
    }
  };

  render() {
    const {
      loading,
      selectedSiswa,
      listTagihan,
      showFilter,
      listSiswa,
      selectedBills,
      filterCriteria,
      listTahunAjaran,
      previousTransaction,
      showPreviousTransactionModal,
      checkOutModal,
      paymentChannelModalVisible,
      paymentMethod,
      successCheckOutModal,
      qrisObject,
      selectedTagihanBulan,
      paymentChannels,
    } = this.state;

    urlValues = queryString.parse(this.props.location.search);

    const VA_METHOD = paymentChannels.filter((p) => p.type === "va");
    const EWALLET_METHOD = paymentChannels.filter((p) => p.type === "ewallet");

    const ECOMMERCE_METHOD = paymentChannels.filter(
      (p) => p.type === "ecommerce"
    );

    // const VA_METHOD = this.PAYMENT_METHODS.filter((p) => p.type === "va");
    // const EWALLET_METHOD = this.PAYMENT_METHODS.filter(
    //   (p) => p.type === "ewallet"
    // );
    // const ECOMMERCE_METHOD = this.PAYMENT_METHODS.filter(
    //   (p) => p.type === "ecommerce"
    // );

    return (
      <View style={{ flex: 1 }}>
        <FormModal
          title={<span>Filter</span>}
          visible={showFilter}
          onClose={(e) => {
            if (e) e.preventDefault();
            this.setState({
              showFilter: false,
            });
          }}
          onSubmit={this.submitFilter}
        >
          <div className="form-group">
            <label>Siswa</label>
            <select
              className="form-control"
              value={filterCriteria.studentId}
              onChange={this.handleFilterCriteria("studentId")}
              required
            >
              <option value="" disabled>
                Pilih Siswa
              </option>
              {listSiswa.map((siswa) => (
                <option value={siswa._id}>{siswa.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Jenis Tagihan</label>
            <select
              className="form-control"
              value={filterCriteria.type}
              onChange={this.handleFilterCriteria("type")}
            >
              <option value="">Semua Jenis Tagihan</option>
              <option value="Bulanan">Bulanan</option>
              <option value="Insidental">Insidental</option>
            </select>
          </div>
          <div className="form-group">
            <label>Tahun Ajaran</label>
            <select
              className="form-control"
              value={filterCriteria.academicYear}
              onChange={this.handleFilterCriteria("academicYear")}
              required
            >
              <option value="" disabled>
                Pilih Tahun Ajaran
              </option>
              {listTahunAjaran.map((ta) => (
                <option value={ta.label}>
                  {ta.label} {ta.inProgress ? "(On Going)" : ""}
                </option>
              ))}
            </select>
          </div>
        </FormModal>

        <FormModal
          title={<span>Ooppss!!. Ada Tagihan Belum Dibayar</span>}
          visible={showPreviousTransactionModal}
          onClose={(e) => {
            if (e) e.preventDefault();
            this.setState({
              previousTransaction: null,
              showPreviousTransactionModal: false,
              selectedBills: [],
            });
          }}
        >
          {previousTransaction ? (
            <div>
              <p className="mb-4 text-justify">
                Anda memiliki tagihan yang belum dibayar. Silahkan melanjutkan
                pembayaran atau batalkan tagihan ini
              </p>

              <div
                className="d-flex justify-content-between mb-2"
                style={{
                  fontSize: 14,
                }}
              >
                <p className="mb-0">Trx. Id</p>
                <p className="mb-0">
                  {" "}
                  {previousTransaction._id.replace(/[0-9]/g, "x")}
                </p>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <p
                  className="mb-0"
                  style={{
                    fontSize: 14,
                  }}
                >
                  Tgl. Trans
                </p>
                <p
                  className="mb-0"
                  style={{
                    fontSize: 14,
                  }}
                >
                  <b>
                    {dayjs(previousTransaction._createdAt).format(
                      "YYYY-MM-DD HH:mm"
                    )}
                  </b>
                </p>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <p
                  className="mb-0"
                  style={{
                    fontSize: 12,
                  }}
                >
                  Customer
                </p>
                <p
                  className="mb-0"
                  style={{
                    fontSize: 12,
                  }}
                >
                  <b>{previousTransaction.customerName}</b>
                </p>
              </div>
              <hr className="mb-2 mt-0" />
              <center>
                <h5>
                  <b>Detil Transaksi</b>
                </h5>
              </center>

              <div
                className="row"
                style={{
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                <div className="col-5">Tagihan</div>
                <div className="col-1 text-center">Qty</div>
                <div className="col-6 text-right">Nominal (Rp)</div>
              </div>

              <hr className="m-0" />

              {previousTransaction.billDetails.length > 0
                ? previousTransaction.billDetails.map((det) => (
                    <div className="row mb-2">
                      <div
                        className="col-5"
                        style={{
                          fontSize: 10,
                          flex: 1,
                        }}
                      >
                        {det.item}
                      </div>
                      <div
                        className="col-1 text-center"
                        style={{
                          fontSize: 10,
                        }}
                      >
                        {det.qty}
                      </div>
                      <div
                        className="col-6 text-right"
                        style={{
                          fontSize: 10,
                        }}
                      >
                        Rp.{" "}
                        {Number(det.price)
                          .toLocaleString("id-ID")
                          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                      </div>
                    </div>
                  ))
                : null}

              <hr className="m-0" />

              <div
                className="row"
                style={{
                  fontSize: 10,
                }}
              >
                <div className="col-6">Sub Total</div>
                <div
                  className="col-6 text-right"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Rp.{" "}
                  {Number(previousTransaction.totalAmount)
                    .toLocaleString("id-ID")
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                </div>
                <div className="col-6">Fee</div>
                <div
                  className="col-6 text-right"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Rp.{" "}
                  {Number(previousTransaction.fee)
                    .toLocaleString("id-ID")
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                </div>
                <div className="col-6">Grand Total</div>
                <div
                  className="col-6 text-right"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Rp.{" "}
                  {Number(
                    previousTransaction.fee + previousTransaction.totalAmount
                  )
                    .toLocaleString("id-ID")
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                </div>
              </div>

              <div
                style={{
                  marginTop: 20,
                }}
              >
                <center>
                  <a href={previousTransaction.paymentUrl} target="__blank">
                    <button
                      className="btn btn-sm btn-success"
                      style={{
                        marginBottom: 20,
                      }}
                    >
                      <i className="fa fa-paper-plane" /> Lanjutkan
                    </button>
                  </a>
                </center>
                <center>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={this.handleCancel(previousTransaction)}
                  >
                    <i className="fa fa-times-circle" /> Batalkan
                  </button>
                </center>
              </div>
            </div>
          ) : null}
        </FormModal>

        <FormModal
          title={
            <span>
              <i className="fa fa-money-bill-wave" /> Detil Pembayaran
            </span>
          }
          visible={checkOutModal.visible}
          onClose={(e) => {
            this.closeCheckOutModal();
          }}
        >
          {paymentMethod === "tokopedia" || paymentMethod === "shopee" ? (
            <div className="mb-2">
              <p style={{ textAlign: "justify" }}>
                Biaya transaksi dengan {paymentMethod.toUpperCase()} akan
                dikenakan biaya administrasi Rp. {checkOutModal.fee}
                /transaksi.
              </p>

              <p style={{ textAlign: "justify" }}>
                <b>
                  Biaya admin tersebut belum termasuk biaya admin dari{" "}
                  {paymentMethod.toUpperCase()}
                </b>
              </p>
            </div>
          ) : null}

          <div className="d-flex justify-content-between mb-2">
            <p
              className="mb-0"
              // style={{
              //   fontSize: 12,
              // }}
            >
              Tagihan
            </p>
            <p
              className="mb-0"
              // style={{
              //   fontSize: 12,
              // }}
            >
              Nominal Tagihan (Rp)
            </p>
          </div>
          <hr
            style={{
              marginTop: 0,
              marginBottom: 0,
              borderColor: "#000",
            }}
          />
          {selectedBills.map((det) => (
            <div>
              <div className="d-flex justify-content-between">
                <p className="mb-0">{det.StudentBillType.name}</p>
                <p className="mb-0">
                  {Number(det.unpaid)
                    .toLocaleString("id-ID")
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                </p>
              </div>
            </div>
          ))}

          <hr
            style={{
              marginTop: 0,
              marginBottom: 0,
              borderColor: "#000",
            }}
          />
          <div className="d-flex justify-content-between mb-1 mt-4">
            <p className="mb-0">Total Tagihan</p>
            <p className="mb-0">
              <b>
                Rp.{" "}
                {Number(checkOutModal.totalBill)
                  .toLocaleString("id-ID")
                  .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
              </b>
            </p>
          </div>
          <div className="d-flex justify-content-between mb-1">
            <p className="mb-0">Administrasi</p>
            <p className="mb-0">
              <b>
                Rp.{" "}
                {Number(checkOutModal.fee)
                  .toLocaleString("id-ID")
                  .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
              </b>
            </p>
          </div>

          <div className="d-flex justify-content-between mb-1">
            <p className="mb-0">Sub. Total</p>
            <p className="mb-0">
              <b>
                Rp.{" "}
                {Number(checkOutModal.total)
                  .toLocaleString("id-ID")
                  .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
              </b>
            </p>
          </div>

          <div className="mt-4">
            <div
              className="d-flex justify-content-center"
              // onClick={this.openPaymentChannel}
              onClick={this.submitPayment}
            >
              <div className="btn btn-sm btn-success">
                <i className="fa fa-check-circle" /> Lanjutkan Pembayaran
              </div>
            </div>
          </div>
        </FormModal>

        <FormModal
          title={
            <span>
              <i className="fa fa-money-bill-wave" /> Payment Channel
            </span>
          }
          visible={paymentChannelModalVisible}
          onClose={(e) => {
            this.setState({
              paymentChannelModalVisible: false,
              checkOutModal: {
                visible: false,
                total: 0,
                fee: 0,
                totalBill: 0,
              },
              selectedBills: [],
              paymentMethod: "",
            });
          }}
          onSubmit={this.openCheckOut(selectedBills)}
          // onSubmit={this.submitPayment}
        >
          <center>
            <Image
              style={{ width: 200, height: 200 }}
              source={require("../../assets/smartphone-payment.jpg")}
            />
          </center>

          <div>
            {selectedSiswa && selectedSiswa.PREFIX !== "RAHMATANSCHOOL" ? (
              <div>
                <div
                  className="mb-4"
                  style={{
                    // display: urlValues.PREFIX === "DEMO" ? "block" : "none",
                    display: EWALLET_METHOD.length > 0 ? "block" : "none",
                  }}
                >
                  <h5>E-Wallet</h5>
                  <div className="d-flex flex-column">
                    {EWALLET_METHOD.map((payment) => (
                      <section
                        className="card"
                        onClick={this.handleSelectPayment(payment.name)}
                        style={{
                          borderWidth: "4px",
                          borderRadius: "10px",
                          borderColor:
                            paymentMethod === payment.name
                              ? "#00a8ff"
                              : "#bdc3c7",
                          marginBottom: "5px",
                          // border: "block",
                          padding: 10,
                          marginBottom: 10,
                          // display:
                          //   payment.name === "ovo" || payment.name === "dana"
                          //     ? "none"
                          //     : "block",
                        }}
                      >
                        <div className="d-flex flex-row">
                          <View style={{ height: 50 }}>
                            <Image
                              style={{ width: 50, height: 50 }}
                              resizeMode="contain"
                              // source={require("../../assets/bca-logo.png")}
                              source={
                                payment.name === "linkAja"
                                  ? require("../../assets/linkAja.png")
                                  : ""
                              }
                            />
                          </View>
                          <div
                            className="d-flex align-items-center"
                            style={{
                              marginLeft: 10,
                            }}
                          >
                            <h5
                              style={{
                                margin: 0,
                              }}
                            >
                              {payment.label}
                            </h5>
                          </div>
                        </div>
                      </section>
                    ))}
                  </div>
                </div>
                {/* {router.query.PREFIX === "DEMO" ? (
                    <div className="mb-4">
                      <h5>QRIS</h5>
                      <div className="d-flex flex-column">
                        {QRIS_METHOD.map((payment) => (
                          <section
                            className="card"
                            onClick={this.handleSelectPayment(payment.name)}
                            style={{
                              borderWidth: "4px",
                              borderRadius: "10px",
                              borderColor:
                                paymentMethod === payment.name
                                  ? "#00a8ff"
                                  : "#bdc3c7",
                              marginBottom: "5px",
                              padding: 10,
                              marginBottom: 10,
                            }}
                          >
                            <div className="d-flex flex-row">
                              <img
                                src={payment.icon}
                                width="50"
                                height={37.5}
                              />
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  marginLeft: 10,
                                }}
                              >
                                <h5
                                  style={{
                                    margin: 0,
                                  }}
                                >
                                  {payment.label}
                                </h5>
                              </div>
                            </div>
                          </section>
                        ))}
                      </div>
                    </div>
                  ) : null} */}
              </div>
            ) : null}
          </div>
          {selectedSiswa && selectedSiswa.PREFIX === "DEMO" ? (
            <div
              className="mb-4"
              style={{
                display:
                  selectedSiswa && selectedSiswa.PREFIX === "DEMO"
                    ? "block"
                    : "none",
              }}
            >
              <h5>E-Commerce</h5>
              <div className="d-flex flex-column">
                {ECOMMERCE_METHOD.map((payment) => (
                  <section
                    className="card"
                    onClick={this.handleSelectPayment(payment.name)}
                    // onClick={
                    //   checkHideSchoolPay === true
                    //     ? null
                    //     : this.handleSelectPayment(payment.name)
                    // }
                    style={{
                      borderWidth: "4px",
                      borderRadius: "10px",
                      borderColor:
                        this.state.paymentMethod === payment.name
                          ? "#00a8ff"
                          : "#bdc3c7",
                      marginBottom: "5px",
                      // border: "block",
                      padding: 10,
                      marginBottom: 10,
                    }}
                  >
                    <div className="d-flex flex-row">
                      <img
                        src={payment.icon}
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                        }}
                      />
                      <div
                        className="d-flex align-items-center"
                        style={{
                          marginLeft: 10,
                        }}
                      >
                        <h5
                          style={{
                            margin: 0,
                          }}
                        >
                          {payment.label}
                        </h5>
                      </div>
                    </div>
                  </section>
                ))}
              </div>
            </div>
          ) : null}

          <div className="d-flex flex-column">
            <h5>Virtual Account</h5>
            {VA_METHOD.filter((p) => p.type === "va").map((payment) => {
              if (selectedSiswa && selectedSiswa.PREFIX === "RAHMATANSCHOOL") {
                if (payment.name === "bsi") {
                  return (
                    <section
                      className="card"
                      onClick={this.handleSelectPayment(payment.name)}
                      style={{
                        borderWidth: "4px",
                        borderColor:
                          paymentMethod === payment.name
                            ? "#00a8ff"
                            : "#bdc3c7",
                        marginBottom: "5px",
                        borderRadius: "10px",
                        padding: 10,
                        marginBottom: 10,
                        // display:
                        //   payment.name === "ovo" || payment.name === "dana"
                        //     ? "none"
                        //     : "block",
                      }}
                    >
                      <View
                        style={{
                          flex: 1,
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <View style={{ height: 50 }}>
                          <Image
                            style={{ width: 50, height: 50 }}
                            resizeMode="contain"
                            // source={require("../../assets/BSI_logo.png")}
                          />
                        </View>
                        <View
                          style={{ width: 250, height: 50, marginLeft: 10 }}
                        >
                          <Text style={{ marginTop: 13, fontSize: 20 }}>
                            {payment.label}
                          </Text>
                        </View>
                      </View>
                    </section>
                  );
                } else {
                  return <div />;
                }
              }
              return (
                <section
                  className="card"
                  onClick={this.handleSelectPayment(payment.name)}
                  style={{
                    borderWidth: "4px",
                    borderColor:
                      paymentMethod === payment.name ? "#00a8ff" : "#bdc3c7",
                    marginBottom: "5px",
                    borderRadius: "10px",
                    padding: 10,
                    marginBottom: 10,
                    display: payment.display,
                  }}
                >
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <View style={{ height: 50 }}>
                      <Image
                        style={{ width: 50, height: 50 }}
                        resizeMode="contain"
                        // source={require("../../assets/bca-logo.png")}
                        source={
                          payment.name === "bca"
                            ? require("../../assets/bca-logo.png")
                            : payment.name === "bri"
                            ? require("../../assets/Logo-Bank-BRI.png")
                            : payment.name === "bni"
                            ? require("../../assets/Logo-BNI-46.png")
                            : payment.name === "mandiri"
                            ? require("../../assets/Logo-Bank-Mandiri.png")
                            : payment.name === "cimb"
                            ? require("../../assets/cimb.png")
                            : payment.name === "permata"
                            ? require("../../assets/permata.png")
                            : payment.name === "bsi"
                            ? require("../../assets/BSI_logo.png")
                            : ""
                        }
                      />
                    </View>
                    <View style={{ width: 250, height: 50, marginLeft: 10 }}>
                      <Text style={{ marginTop: 13, fontSize: 20 }}>
                        {payment.label}
                      </Text>
                    </View>
                  </View>
                </section>
              );
            })}
          </div>
        </FormModal>

        <FormModal
          visible={successCheckOutModal.visible}
          title={<span>{`Pembayaran via ${paymentMethod.toUpperCase()}`}</span>}
          onClose={(e) => {
            if (e) e.preventDefault();
            this.setState({
              successCheckOutModal: {
                visible: false,
                vaNumber: "",
                bankCode: "",
              },
            });
          }}
        >
          <div className="text-center">
            <h5 style={{ marginBottom: 10 }}>
              Harap Bayar Tagihan Anda Pada VA:
            </h5>
            <h3 style={{ color: "#0277bd" }}>
              {successCheckOutModal.vaNumber
                ? successCheckOutModal.vaNumber
                : "-"}
            </h3>

            <CopyToClipboard
              text={successCheckOutModal.vaNumber}
              onCopy={() => {
                this.setState({ vaCopied: true });
                addNotification({
                  level: "success",
                  message: "Copied",
                });
              }}
            >
              <button className="btn btn-sm btn-primary">
                <i className="fa fa-copy" /> Copy to Clipboard
              </button>
            </CopyToClipboard>

            {paymentMethod === "bca" ? (
              <div>
                <div>
                  <p>Kunjungi link dibawah ini untuk petunjuk pembayaran: </p>
                  <div className="form-group">
                    <label>&middot;BCA Mobile Banking/M-BCA</label> <br />
                    <a href="https://youtu.be/SlcGsxJpBRs">
                      https://youtu.be/SlcGsxJpBRs
                    </a>
                  </div>
                </div>
              </div>
            ) : paymentMethod === "mandiri" ? (
              <div>
                <p>Kunjungi link dibawah ini untuk petunjuk pembayaran: </p>
                <div className="form-group">
                  <label>&middot;Mandiri Mobile Banking</label> <br />
                  <a href="https://youtu.be/c4LtIswc-80">
                    https://youtu.be/c4LtIswc-80
                  </a>
                </div>
              </div>
            ) : paymentMethod === "bsi" ? (
              <div>
                <p>Kunjungi link dibawah ini untuk petunjuk pembayaran: </p>
                <div className="form-group">
                  <label>&middot;BSI Mobile Banking</label> <br />
                  <a href="https://youtu.be/SPUFn6puwjE">
                    https://youtu.be/SPUFn6puwjE
                  </a>
                </div>
              </div>
            ) : paymentMethod === "bri" ? (
              <div>
                <p>Kunjungi link dibawah ini untuk petunjuk pembayaran: </p>
                <div className="form-group">
                  <label>&middot;BRI Mobile Banking</label> <br />
                  <a href="ttps://youtu.be/lnwdxQum4p4">
                    ttps://youtu.be/lnwdxQum4p4
                  </a>
                </div>
              </div>
            ) : paymentMethod === "bni" ? (
              <div>
                <p>Kunjungi link dibawah ini untuk petunjuk pembayaran: </p>
                <div className="form-group">
                  <label>&middot;BNI Mobile Banking</label> <br />
                  <a href="https://youtu.be/rpIM1rxd-Zk">
                    https://youtu.be/rpIM1rxd-Zk
                  </a>
                </div>
              </div>
            ) : paymentMethod === "cimb" ? (
              <div>
                <p>Kunjungi link dibawah ini untuk petunjuk pembayaran: </p>
                <div className="form-group">
                  <label>&middot;CIMB Niaga Mobile Banking</label> <br />
                  <a href="https://youtu.be/pwytIZAue_U">
                    https://youtu.be/pwytIZAue_U
                  </a>
                </div>
              </div>
            ) : paymentMethod === "permata" ? (
              <div>
                <p>Kunjungi link dibawah ini untuk petunjuk pembayaran: </p>
                <div className="form-group">
                  <label>&middot;Permata Mobile Banking</label> <br />
                  <a href="https://youtu.be/U4kO6QcPsro">
                    https://youtu.be/U4kO6QcPsro
                  </a>
                </div>
              </div>
            ) : null}
          </div>
        </FormModal>
        <div className="fixed-top">
          <StatusBar
            backgroundColor="#1696ff"
            barStyle="light-content"
            animated={true}
          />
        </div>

        <BackgroundImage />
        <LoadingOverlay loading={loading} />

        <div className="fixed-top">
          <HeaderBar
            title={
              <Text>
                <i
                  className="fa fa-file-invoice"
                  style={{
                    fontSize: 20,
                  }}
                />{" "}
                {translate("Tagihan dan Pembayaran")}
              </Text>
            }
            right={
              <TouchableOpacity onPress={this.refresh}>
                <Text
                  style={{
                    paddingRight: 12,
                    paddingLeft: 20,
                    color: "white",
                    fontSize: 16,
                    paddingVertical: 2,
                  }}
                >
                  <i
                    className="fa fa-sync-alt"
                    style={{
                      fontSize: 20,
                      marginBottom: 5,
                    }}
                  />
                </Text>
              </TouchableOpacity>
            }
          />

          <div
            style={{
              backgroundColor: "#fff",
            }}
            ref={(divElement) => {
              this.divElement = divElement;
            }}
          >
            <div>
              {loading ? (
                <ShimmerThumbnail className="m-0" rounded />
              ) : (
                <div className="py-2 px-2">
                  <div className="row justify-content-center">
                    <div className="col-3">
                      <Image
                        style={{ width: 80, height: 80 }}
                        // source={require("../assets/owl-laptop-study.png")}
                        source={require("../../assets/owl-laptop-study.png")}
                      />
                    </div>
                    <div className="col-9 p-0 d-flex align-items-center">
                      <div
                        style={{
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <p
                          style={{
                            fontSize: 16,
                            margin: 0,
                          }}
                        >
                          {selectedSiswa
                            ? selectedSiswa.name.length < 30
                              ? selectedSiswa.name
                              : selectedSiswa.name.slice(0, 27) + "..."
                            : ""}
                        </p>

                        <p
                          className="m-0"
                          style={{
                            fontSize: 14,
                            margin: 0,
                          }}
                        >
                          <b>
                            {selectedSiswa && selectedSiswa.SchoolInformation
                              ? selectedSiswa.SchoolInformation.name.length <=
                                30
                                ? selectedSiswa.SchoolInformation.name
                                : selectedSiswa.SchoolInformation.name.slice(
                                    0,
                                    27
                                  ) + "..."
                              : "-"}
                          </b>
                        </p>
                      </div>
                      <i
                        className="fa fa-filter ml-4"
                        style={{
                          fontSize: 18,
                        }}
                        onClick={this.openFilter}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="px-2"
          style={{
            marginTop:
              this.state.height < 100
                ? this.state.height + 100
                : this.state.height + 10,
          }}
        >
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            <button className="btn btn-md btn-primary mr-2">
              Daftar Tagihan
            </button>
            <button className="btn btn-md btn-light" onClick={this.openHistory}>
              Riwayat Pembayaran
            </button>
          </View>
          <View
            style={{
              flex: 1,
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontSize: 25,
                marginBottom: 10,
              }}
            >
              Daftar Tagihan
            </Text>
          </View>

          <View
            style={{
              marginBottom: "50px",
              backgroundColor: "#fff",
              borderRadius: "10px",
            }}
          >
            {loading || !listTagihan ? (
              <ShimmerThumbnail className="m-0" rounded />
            ) : (
              Object.keys(listTagihan).map((tagihan) => {
                const dataTagihan = lodash.get(listTagihan, tagihan, []);
                const clickedTagihanIndex = selectedTagihanBulan.findIndex(
                  (t) => t === tagihan
                );
                const tagihanBelumLunas = dataTagihan.filter(
                  (t) => t.status !== "LUNAS"
                );
                return (
                  <div className="mb-2">
                    <div className="px-2 py-2">
                      <div
                        className="d-flex justify-content-between align-items-center"
                        onClick={this.expandTagihan(tagihan)}
                      >
                        <div className="d-flex flex-column">
                          <p
                            className="m-0"
                            style={{
                              fontSize: 18,
                            }}
                          >
                            <b>
                              Tagihan {tagihan} -{" "}
                              {dataTagihan.length > 0
                                ? dataTagihan[0].academicYear
                                : ""}
                            </b>
                          </p>
                          <p
                            className="m-0"
                            style={{
                              fontSize: 12,
                              color:
                                tagihanBelumLunas.length > 0 ? "red" : "green",
                            }}
                          >
                            <b>
                              Terdapat {tagihanBelumLunas.length} tagihan belum
                              lunas
                            </b>
                          </p>
                        </div>
                        <p
                          className="m-0"
                          style={{
                            fontSize: 18,
                          }}
                        >
                          {clickedTagihanIndex > -1 ? (
                            <i className="fa fa-caret-up" />
                          ) : (
                            <i className="fa fa-caret-down" />
                          )}
                        </p>
                      </div>
                      {dataTagihan.map((t) => {
                        const index = selectedBills
                          .map((b) => b._id)
                          .findIndex((bi) => bi === t._id);

                        if (clickedTagihanIndex === -1) {
                          return <div />;
                        }

                        return (
                          <div
                            className="card"
                            style={{
                              marginBottom: 10,
                              borderRadius: 10,
                            }}
                            onClick={
                              t.status === "LUNAS"
                                ? null
                                : this.handleSelectBill(t)
                            }
                          >
                            <div
                              className="card-header d-flex flex-row justify-content-left align-items-center"
                              style={{
                                backgroundColor:
                                  t.status === "LUNAS"
                                    ? "#66BB6A"
                                    : t.status === "BELUM LUNAS" && index < 0
                                    ? "#F44336"
                                    : "#1976D2",
                                color: "#fff",
                                fontSize: 16,
                                borderTopLeftRadius: 10,
                                borderTopRightRadius: 10,
                              }}
                            >
                              <div style={{ marginLeft: 10 }}>
                                <b>{t.StudentBillType.name.toUpperCase()}</b>
                              </div>
                            </div>

                            <div
                              className="card-body"
                              style={{
                                fontSize: 16,
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center">
                                <div
                                  className="d-flex flex-column"
                                  style={{
                                    flex: 1,
                                  }}
                                >
                                  <div className="row">
                                    <div
                                      className="col-5 p-0"
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      Nominal:
                                    </div>
                                    <div
                                      className="col-7 pl-2"
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      <b>
                                        Rp.{" "}
                                        {Number(t.amount)
                                          .toLocaleString("id-ID")
                                          .replace(
                                            /(\d)(?=(\d{3})+\.)/g,
                                            "$1,"
                                          )}
                                      </b>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div
                                      className="col-5 p-0"
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      Dibayar:
                                    </div>
                                    <div
                                      className="col-7 pl-2"
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      <b>
                                        Rp.{" "}
                                        {Number(t.paid)
                                          .toLocaleString("id-ID")
                                          .replace(
                                            /(\d)(?=(\d{3})+\.)/g,
                                            "$1,"
                                          )}
                                      </b>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div
                                      className="col-5 p-0"
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      Sisa:
                                    </div>
                                    <div
                                      className="col-7 pl-2"
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      <b>
                                        Rp.{" "}
                                        {Number(t.unpaid)
                                          .toLocaleString("id-ID")
                                          .replace(
                                            /(\d)(?=(\d{3})+\.)/g,
                                            "$1,"
                                          )}
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <Image
                                    style={{ width: 80, height: 80 }}
                                    source={
                                      t.status === "LUNAS"
                                        ? require("../../assets/st-bill-img-pay-done.svg")
                                        : require("../../assets/st-bill-img-pay.svg")
                                    }
                                  />
                                  <center>
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: 12,
                                        color:
                                          t.status === "LUNAS"
                                            ? "#66BB6A"
                                            : "#F44336",
                                      }}
                                    >
                                      <b>{t.status}</b>
                                    </p>
                                  </center>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {/* {dataTagihan.map((t) => {
                        const index = selectedBills
                          .map((b) => b._id)
                          .findIndex((bi) => bi === t._id);
                        return (
                          <div
                            className={"px-2 py-2 mb-2 shadow"}
                            style={{
                              backgroundColor: "#fff",
                              border:
                                t.status === "LUNAS"
                                  ? "3px solid rgb(114, 248, 8)"
                                  : t.status === "BELUM LUNAS" && index < 0
                                  ? "3px solid rgb(250, 46, 32)"
                                  : "3px solid rgb(45, 14, 237)",
                              borderRadius: "10px",
                            }}
                            onClick={
                              t.status === "LUNAS"
                                ? null
                                : this.handleSelectBill(t)
                            }
                          >
                            <View
                              style={{
                                flex: 1,
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginBottom: 5,
                              }}
                            >
                              <View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                  }}
                                >
                                  Tagihan
                                </Text>
                              </View>
                              <View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t.StudentBillType.name.toUpperCase()}
                                </Text>
                              </View>
                            </View>
                            <View
                              style={{
                                flex: 1,
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginBottom: 5,
                              }}
                            >
                              <View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                  }}
                                >
                                  Nominal
                                </Text>
                              </View>
                              <View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Rp.{" "}
                                  {Number(t.amount)
                                    .toLocaleString("id-ID")
                                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                                </Text>
                              </View>
                            </View>

                            <View
                              style={{
                                flex: 1,
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginBottom: 5,
                              }}
                            >
                              <View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                  }}
                                >
                                  Dibayar
                                </Text>
                              </View>
                              <View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Rp.{" "}
                                  {Number(t.paid)
                                    .toLocaleString("id-ID")
                                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                                </Text>
                              </View>
                            </View>

                            <View
                              style={{
                                flex: 1,
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginBottom: 5,
                              }}
                            >
                              <View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                  }}
                                >
                                  Sisa Bayar
                                </Text>
                              </View>
                              <View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Rp.{" "}
                                  {Number(t.unpaid)
                                    .toLocaleString("id-ID")
                                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                                </Text>
                              </View>
                            </View>
                          </div>
                        );
                      })} */}
                      <hr style={{ margin: 5, borderColor: "#000" }} />
                    </div>
                  </div>
                );
              })
            )}
          </View>
        </div>

        <div className="fixed-bottom">
          <button
            className="btn btn-sm btn-primary btn-block py-2"
            // onClick={this.openCheckOut(selectedBills)}
            onClick={selectedBills.length > 0 ? this.openPaymentChannel : null}
          >
            <i className="fa fa-shopping-cart" /> Bayar {selectedBills.length}{" "}
            Tagihan
          </button>
          {/* <div className="d-flex justify-content-center">
            <button
              className="btn btn-sm btn-primary mx-2"
              style={{
                borderRadius: "50%",
                width: "50px",
                height: "50px",
              }}
              onClick={this.openFilter}
            >
              <i className="fa fa-filter" />
            </button>

            {selectedBills.length === 0 ? (
              <button
                className="btn btn-sm mx-2"
                style={{
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#B0BEC5",
                  color: "#fff",
                }}
              >
                <i className="fa fa-shopping-cart" />
              </button>
            ) : (
              <button
                className="btn btn-sm btn-success mx-2"
                style={{
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  position: "relative",
                }}
                onClick={this.openCheckOut(selectedBills)}
              >
                <i className="fa fa-shopping-cart" />

                <span
                  style={{
                    position: "absolute",
                    width: "20px",
                    height: "20px",
                    right: 0,
                    top: -10,
                    color: "#fff",
                    backgroundColor: "red",
                    borderRadius: "50%",
                    fontSize: 16,
                  }}
                >
                  {selectedBills.length}
                </span>
              </button>
            )}

            <button
              className="btn btn-sm btn-info mx-2"
              style={{
                borderRadius: "50%",
                width: "50px",
                height: "50px",
              }}
              onClick={this.openHistory}
            >
              <i className="fa fa-history" />
            </button>
          </div> */}
        </div>
      </View>
    );
  }

  handleCancel = (previousTransaction) => async (e) => {
    if (e) e.preventDefault();
    showLoadingSpinner();
    try {
      if (
        window.confirm(
          "Apakah Anda yakin untuk membatalkan transaksi ini? Transaksi yang dibatalkan tidak dapat digunakan kembali"
        )
      ) {
        await mwvClient.mutate({
          mutation: CANCEL_WAITING_TRANSACTION,
          variables: {
            _id: previousTransaction._id,
          },
          fetchPolicy: "no-cache",
        });

        addNotification({
          level: "success",
          message: "Tagihan dibatalkan",
        });

        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);

        this.setState({
          previousTransaction: null,
          showPreviousTransactionModal: false,
          selectedBills: [],
          paymentMethod: "",
          paymentChannelModalVisible: false,
        });
      }
    } catch (err) {
      handleError(err);
    }
    hideLoadingSpinner();
  };

  submitPayment = async (e) => {
    if (e) e.preventDefault();
    showLoadingSpinner();
    try {
      urlValues = queryString.parse(this.props.location.search);
      const {
        paymentMethod,
        selectedBills,
        checkOutModal,
        successCheckOutModal,
        isPaymentH2H,
      } = this.state;
      if (!paymentMethod) {
        throw {
          message: `Anda belum memilih metode pembayaran tagihan!`,
        };
      }

      const nowHours = dayjs().hour();
      if (nowHours >= 21 || nowHours <= 4) {
        throw {
          message:
            "Cut Off. Silahkan lakukan pembayaran diatas jam 04:00 - 21:00",
        };
      }

      let histories = selectedBills.map((bill) => {
        return {
          studentBillId: bill._id,
          paid: bill.unpaid,
        };
      });

      if (isPaymentH2H) {
        const result = await mwvClient.mutate({
          mutation: CREATE_SCHOOL_PAY_BILL_H2H,
          variables: {
            sessionId: urlValues.sessionId,
            studentBillIds: selectedBills.map((b) => b._id),
            paymentMethod,
            total: checkOutModal.totalBill,
            fee: checkOutModal.fee,
            phoneNumber: "", //this.state.phoneNumber,
            histories,
          },
          fetchPolicy: "no-cache",
        });

        addNotification({
          level: "success",
          message: "Checkout tagihan berhasil",
        });

        const vaDetailResult = JSON.parse(
          result.data.createSchoolPayBillWithH2H.VAPaymentDetail
        );
        if (vaDetailResult.provider === "BNIH2H") {
          this.setState({
            successCheckOutModal: {
              visible: true,
              vaNumber: vaDetailResult.virtualAccount,
              bankCode: "BNI",
            },
            paymentChannelModalVisible: false,
            checkOutModal: {
              visible: false,
              total: 0,
              fee: 0,
              totalBill: 0,
            },
            selectedBills: [],
          });
        }
      } else {
        const result = await mwvClient.mutate({
          mutation: CREATE_SCHOOL_PAY_BILL,
          variables: {
            sessionId: urlValues.sessionId,
            studentBillIds: selectedBills.map((b) => b._id),
            paymentMethod,
            total: checkOutModal.totalBill,
            fee: checkOutModal.fee,
            phoneNumber: "", //this.state.phoneNumber,
            histories,
            PWAMode: true,
          },
          fetchPolicy: "no-cache",
        });

        addNotification({
          level: "success",
          message: "Checkout tagihan berhasil",
        });

        if (
          paymentMethod === "mandiri" ||
          paymentMethod === "bri" ||
          paymentMethod === "bni" ||
          paymentMethod === "bca" ||
          paymentMethod === "bsi" ||
          paymentMethod === "permata" ||
          paymentMethod === "cimb" ||
          paymentMethod === "muamalat" ||
          paymentMethod === "btn" ||
          paymentMethod === "tokopedia" ||
          paymentMethod === "shopee"
        ) {
          if (result.data.createSchoolPayBill.VAPaymentDetail) {
            const vaDetailResult = JSON.parse(
              result.data.createSchoolPayBill.VAPaymentDetail
            );
            if (vaDetailResult.provider === "MCP") {
              this.setState({
                successCheckOutModal: {
                  visible: true,
                  vaNumber: vaDetailResult.payment_code,
                  bankCode: vaDetailResult.bankCode,
                },
                paymentChannelModalVisible: false,
                checkOutModal: {
                  visible: false,
                  total: 0,
                  fee: 0,
                  totalBill: 0,
                },
                selectedBills: [],
              });
            } else if (vaDetailResult.provider === "XENDIT") {
              let vaNumber = "";
              if (vaDetailResult.bank_code === "BSI") {
                vaNumber = vaDetailResult.account_number.slice(
                  4,
                  vaDetailResult.account_number.length
                );
              } else {
                vaNumber = vaDetailResult.account_number;
              }

              this.setState({
                successCheckOutModal: {
                  visible: true,
                  vaNumber,
                  bankCode: vaDetailResult.bank_code,
                },
                paymentChannelModalVisible: false,
                checkOutModal: {
                  visible: false,
                  total: 0,
                  fee: 0,
                  totalBill: 0,
                },
                selectedBills: [],
              });
            } else if (vaDetailResult.provider === "FASPAY") {
              this.setState({
                successCheckOutModal: {
                  visible: true,
                  vaNumber: vaDetailResult.va_number,
                  bankCode: vaDetailResult.bankCode,
                },
                paymentChannelModalVisible: false,
                checkOutModal: {
                  visible: false,
                  total: 0,
                  fee: 0,
                  totalBill: 0,
                },
                selectedBills: [],
              });
            } else if (vaDetailResult.provider === "SEVIMA") {
              this.setState({
                successCheckOutModal: {
                  visible: true,
                  vaNumber: vaDetailResult.virtual_account,
                  bankCode: vaDetailResult.bankCode,
                },
                paymentChannelModalVisible: false,
                checkOutModal: {
                  visible: false,
                  total: 0,
                  fee: 0,
                  totalBill: 0,
                },
                selectedBills: [],
              });
            }
          }
        } else if (paymentMethod === "linkAja") {
          const bill = result.data.createSchoolPayBill;
          if (
            bill.paymentMethod === "dana" ||
            bill.paymentMethod === "linkAja"
          ) {
            window.location.href = bill.checkoutUrl;
            return;
          }
        }
      }
    } catch (err) {
      handleError(err);
    }
    hideLoadingSpinner();
  };
}

const mwvClient = new ApolloClient({
  uri: "https://api.mwv.softwaresekolah.co.id/graphql",
  // uri: "http://localhost:9001/graphql",
});

const ALL_STUDENT_QUERIES = gql`
  query listQuery($_id: String, $PREFIX: String) {
    allStudentBySessionId(sessionId: $_id) {
      _id
      name
      SchoolInformation {
        _id
        name
      }
      Classroom {
        _id
        academicYear
      }
      PREFIX
      photoUrl
    }
    allAcademicYears(PREFIX: $PREFIX) {
      _id
      label
      inProgress
    }
    h2hChecker(PREFIX: $PREFIX) {
      name
      label
      icon
      type
      isH2H
    }
  }
`;

const ALL_ACADEMIC_YEAR_BY_STUDENT = gql`
  query allAcademicYearsByStudent($studentId: String) {
    allAcademicYearsByStudent(studentId: $studentId) {
      _id
      label
      inProgress
    }
  }
`;

const ALL_STUDENT_BILLS = gql`
  query allStudentBillNew(
    $studentId: String!
    $academicYear: String!
    $type: String!
  ) {
    allStudentBillNew(
      studentId: $studentId
      academicYear: $academicYear
      type: $type
    ) {
      _id
      academicYear
      StudentBillType {
        _id
        name
        academicYear
      }
      month
      amount
      paid
      unpaid
      tags
      status
    }
  }
`;

const CHECK_PREVIOUS_TRANSACTION = gql`
  mutation checkPreviousTransaction($sessionId: String!) {
    checkPreviousTransaction(sessionId: $sessionId) {
      _id
      total
      fee
      paymentMethod
      transactionNumber
      status
      VAPaymentDetail
      Histories {
        _id
        StudentBill {
          _id
          StudentBillType {
            _id
            name
          }
        }
        paid
      }
      _createdAt
      expiredAt
    }
  }
`;

const CANCEL_WAITING_TRANSACTION = gql`
  mutation cancelTransactionV2($_id: String!) {
    cancelTransactionV2(_id: $_id)
  }
`;

const CREATE_SCHOOL_PAY_BILL = gql`
  mutation createSchoolPayBill(
    $sessionId: String!
    $studentBillIds: [String]
    $paymentMethod: String!
    $total: Int!
    $fee: Int!
    $histories: [CreatePaidHistory]
    $phoneNumber: String
    $PWAMode: Booelan
  ) {
    createSchoolPayBill(
      input: {
        sessionId: $sessionId
        studentBillIds: $studentBillIds
        paymentMethod: $paymentMethod
        total: $total
        fee: $fee
        histories: $histories
        phoneNumber: $phoneNumber
        PWAMode: $PWAMode
      }
    ) {
      _id
      expiredAt
      paymentMethod
      total
      transactionNumber
      status
      checkoutUrl

      VAPaymentDetail
      paymentUrl
    }
  }
`;

const CREATE_SCHOOL_PAY_BILL_H2H = gql`
  mutation createSchoolPayBillWithH2H(
    $sessionId: String!
    $studentBillIds: [String]
    $paymentMethod: String!
    $total: Int!
    $fee: Int!
    $histories: [CreatePaidHistory]
    $phoneNumber: String
  ) {
    createSchoolPayBillWithH2H(
      input: {
        sessionId: $sessionId
        studentBillIds: $studentBillIds
        paymentMethod: $paymentMethod
        total: $total
        fee: $fee
        histories: $histories
        phoneNumber: $phoneNumber
      }
    ) {
      _id
      expiredAt
      paymentMethod
      total
      transactionNumber
      status
      checkoutUrl

      VAPaymentDetail
      paymentUrl
    }
  }
`;

const CHECK_IF_SCHOOL_IS_H2H = gql`
  query checkIfUseH2H($PREFIX: String!) {
    checkIfUseH2H(PREFIX: $PREFIX)
  }
`;
const CHECK_PREVIOUS_TRANSACTION_V2 = gql`
  mutation checkPreviousTransactionV2($sessionId: String!) {
    checkPreviousTransactionV2(sessionId: $sessionId) {
      _id
      customerName
      totalAmount
      billDetails {
        _id
        item
        qty
        price
      }
      paymentUrl
      fee
      _createdAt
    }
  }
`;
const CREATE_SCHOOL_PAY_V2 = gql`
  mutation createSchoolPayBillV2(
    $sessionId: String!
    $studentBillIds: [String]
    $total: Int!
    $fee: Int!
    $histories: [CreatePaidHistory]
    $PWAMode: Boolean
    $sourceUrl: String!
  ) {
    createSchoolPayBillV2(
      input: {
        sessionId: $sessionId
        studentBillIds: $studentBillIds
        total: $total
        fee: $fee
        histories: $histories
        PWAMode: $PWAMode
        sourceUrl: $sourceUrl
      }
    )
  }
`;

export default withRouter(
  withI18n("student_bill_and_payment")(StudentBillAndPaymentNewV2)
);
